export enum GACategories {}

export enum GAActions {
  selectFarm = "Select farm"
}

export enum GALabels {
  allFarms = "All farms"
}
